import { render, staticRenderFns } from "./MapsInfo.vue?vue&type=template&id=037ed649"
import script from "./MapsInfo.vue?vue&type=script&lang=js"
export * from "./MapsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports